import * as ActionTypes from "./types";

export function updateBreadcrumb(payload) {
  return {
    type: ActionTypes.UPDATE_BREADCRUMB,
    payload,
  };
}
